import { createStore } from 'vuex'
import auth from './modules/auth';
import shop from './modules/shop';
import cashRegister from './modules/cashRegister';
import userSettings from './modules/userSettings';
import navigation from './modules/navigation';
import runtime from './modules/runtime';
import publicAuth from './modules/publicAuth';
import { onPublicUnauthorized } from '@/services/publicApi';
import { migrateSuite241GestionCommercialeStorage } from '@/support/storageMigration';

migrateSuite241GestionCommercialeStorage();

const store = createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth, 
    shop,
    cashRegister,
    userSettings,
    navigation,
    runtime,
    publicAuth
  }
})

onPublicUnauthorized(() => store.commit('publicAuth/CLEAR'));
export default store;
